import React, { memo, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNil, cond, always, T } from 'ramda';

import { Container } from './textLink.styles';
import { EntityRefData } from '../../entityRefData';
import { isExternalTypeLink } from '../../../utils/links';

const TextLinkComponent = ({ navigationParam, text, contentType, linkStyle, fetchExperience, experiences }) => {
  const isExperienceFetched = !isNil(experiences[navigationParam]);
  const isExternalLink = !isEmpty(isExternalTypeLink(navigationParam));
  const linkTypeMap = {
    experience: {
      fetchMethod: fetchExperience,
      entityType: 'experiences',
    },
  };

  const { entityType } = linkTypeMap[contentType] || {};

  useEffect(() => {
    if (isEmpty(isExternalTypeLink(navigationParam)) && linkTypeMap[contentType]) {
      linkTypeMap[contentType].fetchMethod(navigationParam);
    }
  }, []); //eslint-disable-line

  const renderTargetLink = link => (
    <Container className={linkStyle} to={link}>
      {text}
    </Container>
  );

  const renderLinkWithSlug = () => (
    <EntityRefData id={navigationParam} entityType={entityType}>
      {({ slug } = {}) => renderTargetLink(slug || '')}
    </EntityRefData>
  );

  const renderContent = cond([
    [() => !isExternalLink && isExperienceFetched, renderLinkWithSlug],
    [() => !isExternalLink && !isExperienceFetched, always(text)],
    [T, always(renderTargetLink(navigationParam))],
  ]);

  return <Fragment>{renderContent()}</Fragment>;
};

TextLinkComponent.propTypes = {
  navigationParam: PropTypes.string,
  text: PropTypes.string,
  contentType: PropTypes.string,
  linkStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  fetchExperience: PropTypes.func.isRequired,
  experiences: PropTypes.object,
};

export const TextLink = memo(TextLinkComponent);
